import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Skeleton } from '@mui/material';

import random from 'lodash/random';
import { addOpacity } from 'lib/helpers';

const PREFIX = 'ActionListSkeleton';

const classes = {
    title: `${PREFIX}title`,
    subtitle: `${PREFIX}subtitle`
};

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderBottom: `1px solid ${addOpacity(theme.palette.text.primary, 0.1)}`,

    [`& .${classes.title}`]: {
        fontSize: theme.spacing(2)
    },

    [`& .${classes.subtitle}`]: {
        fontSize: theme.spacing(1.75),
        color: theme.palette.grey[600]
    }
}));

type IProps = {
    showIcon?: boolean;
};

export const ActionListSkeleton: React.FC<IProps> = ({ showIcon = true }) => {
    const renderSkeleton = React.useCallback(
        (_: string, index: number) => (
            <StyledBox key={index}>
                {showIcon && <Skeleton variant="rectangular" width={35} height={35} />}
                <Box marginLeft={showIcon ? 1.5 : 0}>
                    <Skeleton height={24} width={random(40, 200)} />
                    <Skeleton height={21} width={random(40, 200)} />
                </Box>
            </StyledBox>
        ),
        [showIcon]
    );

    return <div>{Array(15).fill('').map(renderSkeleton)}</div>;
};
